/** 용신분석 > 목차 */
export const CONTENTS = [
  { id: 1, title: '📖 용신분석 안내서' },
  { id: 2, title: '1. 종합분석' },
  { id: 3, title: '2. 격국분석, 3. 격국패턴' },
  { id: 4, title: '4. 음양분석, 5. 조후분석' },
  { id: 5, title: '6. 신강/신약, 7. 인공지능 용신 분석' },
  { id: 6, title: '8. 용/희/기/구/한, 9. 선정용신' },
  { id: 7, title: '10. 대운 흐름' },
  { id: 8, title: '11. 용신활용법 ' },
  { id: 9, title: '' },
  { id: 10, title: '' },
];

/** 용신분석 > 페이지네이션 > 목차 인덱스 - 페이지 매칭 */
export const CONTENTS_PAGE_MAP = {
  0: 1,
  1: 2,
  2: 3,
  3: 3,
  4: 4,
  5: 4,
  6: 5,
  7: 5,
  8: 6,
  9: 6,
  10: 7,
  11: 8,
};
